import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PatchHealthConfirmAppointments,
	PatchHealthConfirmAppointmentsModel,
	PatchHealthConfirmAppointmentsParams,
} from 'domain/usecases';

export class RemotePatchHealthConfirmAppointments implements PatchHealthConfirmAppointments {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PatchHealthConfirmAppointmentsModel>,
	) {}

	async patch(
		params: PatchHealthConfirmAppointmentsParams,
	): Promise<PatchHealthConfirmAppointmentsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
